import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { DemoModeService } from './demo-mode.service';

/**
 * /demo = the real signed-in app, replicated on an in-memory store.
 *
 * GATED FROM REAL SESSIONS: an already-authenticated visitor never enters the
 * demo — they'd otherwise see the demo's fake data layered over their real
 * account. They're sent straight to their real dashboard. Only signed-out
 * visitors flip the demo flag on; the login guard then admits them and the
 * demo interceptor answers every request from the in-memory store, saving
 * nothing to the database.
 */
export const demoEntryGuard: CanActivateFn = (): Observable<UrlTree> => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const demo = inject(DemoModeService);

  return auth.isLoading$.pipe(
    filter((loading) => !loading),
    take(1),
    switchMap(() => auth.isAuthenticated$),
    take(1),
    map((isAuthenticated) => {
      if (isAuthenticated) {
        // Real user → their real app, never the demo.
        demo.disable();
        return router.parseUrl('/home');
      }
      demo.enable();
      return router.parseUrl('/home');
    }),
  );
};
